import {
    UsersService
} from '@/common/api.service.js'

export class User {
    constructor ({
        bio = null,
        created_at = null,
        created_by = null,
        email = null,
        firstLogin = null,
        id = null,
        image = null,
        parent = null,
        password = null,
        token = null,
        type = 2,
        username = null,
        updated_at = null
    } = {}) {
        this.bio = bio
        this.created_at = created_at
        this.created_by = created_by
        this.email = email
        this.firstLogin = firstLogin
        this.id = id
        this.image = image
        this.parent = parent
        this.password = password
        this.token = token
        this.type = type
        this.username = username
        this.updated_at = updated_at
    }

    get typeFull () {
        let t = this.type
        switch (t) {
        case 1:
            return 'Admin'
        case 2:
            return 'Utente'
        case 3:
            return 'Gruppo'
        default:
            return ''
        }
    }
}

export function responseAdapter (response) {
    return new User({
        ...response
    })
}

export function requestAdapter (request) {
    return request
}

export function queryAdapter (query) {
    if (!query._page) return query
    let offset = query._page - 1 * query._limit
    if (offset > 0) query._offset = offset
    return query
}

export default {
    getSingle: id => new Promise((resolve, reject) => {
        UsersService.get(id)
            .then(({
                data
            }) => {
                resolve({
                    data: responseAdapter(data.user),
                    id: id
                })
            }).catch(e => {
                reject(e)
            })
    }),
    getList: params => new Promise((resolve, reject) => {
        UsersService.query(queryAdapter(params))
            .then(({
                data,
                headers
            }) => {
                resolve({
                    data: data.map(x => responseAdapter(x)),
                    headers
                })
            }).catch(e => {
                reject(e)
            })
    }),
    create: user => new Promise((resolve, reject) => {
        UsersService.create(requestAdapter(user))
            .then((
                data
            ) => {
                resolve(data)
            }).catch(e => {
                reject(e)
            })
    }),
    update: user => new Promise((resolve, reject) => {
        UsersService.update(user)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    }),
    delete: id => new Promise((resolve, reject) => {
        UsersService.delete(id)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    })
}
